import { EventRegister } from "react-native-event-listeners";
import { IAddress } from "src/domains";

export const HideKeyboardEvent = "HideKeyboardEvent";
export const UpdateCognitoEmailEvent = "UpdateCognitoEmailEvent";
export const BlockUserEvent = "BlockUserEvent";
export const UnblockUserEvent = "UnblockUserEvent";
export const OfferLikeToggleEvent = "OfferLikeToggleEvent";
export const OfferUpdateEvent = "OfferUpdateEvent";
export const CallActionEvent = "CallActionEvent";
export const CallReviewCheckEvent = "CallReviewCheckEvent";
export const CreateReviewEvent = "CreateReviewEvent";
export const CallChatCloseEvent = "CallChatCloseEvent";
export const CallKeepStopCallEvent = "CallKeepStopCallEvent";
export const CallKeepAnswerCallEvent = "CallKeepAnswerCallEvent";
export const CallKeepCancelCallEvent = "CallKeepCancelCallEvent";
export const ChatMessageEvent = "ChatMessageEvent";
export const NotificationEvent = "NotificationEvent";
export const PushNotificationEvent = "PushNotificationEvent";
export const PushNotificationActionEvent = "PushNotificationActionEvent";
export const TabChangeEvent = "TabChangeEvent";
export const MyAddressChangeEvent = "MyAddressChangeEvent";
export const TransactionBuyEvent = "TransactionBuyEvent";
export const TransactionCreditCardEvent = "TransactionCreditCardEvent";
export const LogoutEvent = "LogoutEvent";
export const AccountUpdateIdentificationEvent =
  "AccountUpdateIdentificationEvent";
export const WithdrawalEvent = "WithdrawalEvent";
export const RequestReadEvent = "RequestReadEvent";
export const RequestUnreadCountRefreshEvent = "RequestUnreadCountRefreshEvent";

export const hideKeyboard = () => {
  EventRegister.emit(HideKeyboardEvent);
};

export const updateCognitoEmailEventEmit = () => {
  EventRegister.emit(UpdateCognitoEmailEvent);
};

export const blockUserEventEmit = (id: string) => {
  EventRegister.emit(BlockUserEvent, { id });
};

export const unblockUserEventEmit = (id: string) => {
  EventRegister.emit(UnblockUserEvent, { id });
};

export const offerLikeToggleEmit = (offerId: string) => {
  EventRegister.emit(OfferLikeToggleEvent, { offerId });
};

export const offerUpdateEmit = (
  offerId: string,
  action: "create" | "update" | "delete"
) => {
  EventRegister.emit(OfferUpdateEvent, { offerId, action });
};

export const callActionEmit = (
  callId: string,
  action:
    | "timeout"
    | "cancel"
    | "reject"
    | "approve"
    | "callApprove"
    | "callReject"
    | "callFinish"
    | "subscriptionOnRequestSender"
    | "subscriptionOnRequestOpponent"
) => {
  EventRegister.emit(CallActionEvent, { callId, action });
};

export const callReviewCheckEmit = (callId: string) => {
  EventRegister.emit(CallReviewCheckEvent, { callId });
};

export const createReviewEmit = () => {
  EventRegister.emit(CreateReviewEvent, {});
};

export const callChatCloseEmit = () => {
  EventRegister.emit(CallChatCloseEvent, {});
};

export const callKeepStopCallEmit = () => {
  EventRegister.emit(CallKeepStopCallEvent, {});
};

export const callKeepAnswerCallEmit = (callUUID: string) => {
  EventRegister.emit(CallKeepAnswerCallEvent, { callUUID });
};

export const callKeepCancelCallEmit = (callUUID: string) => {
  EventRegister.emit(CallKeepCancelCallEvent, { callUUID });
};

export const chatMessageEmit = (conversationId: string, type: string) => {
  EventRegister.emit(ChatMessageEvent, { conversationId, type });
};

export const notificationEmit = (id: string) => {
  EventRegister.emit(NotificationEvent, { id });
};

export const pushNotificationEmit = (message: any) => {
  EventRegister.emit(PushNotificationEvent, { message });
};

export const pushNotificationActionEmit = (payload: any) => {
  EventRegister.emit(PushNotificationActionEvent, { payload });
};

export const tabChangeEmit = (tabName: string) => {
  EventRegister.emit(TabChangeEvent, { tabName });
};

export const myAddressChangeEmit = (address: IAddress) => {
  EventRegister.emit(MyAddressChangeEvent, { address });
};

export const transactionBuyEmit = () => {
  EventRegister.emit(TransactionBuyEvent);
};

export const transactionCreditCardEmit = () => {
  EventRegister.emit(TransactionCreditCardEvent);
};

export const logoutEmit = () => {
  EventRegister.emit(LogoutEvent);
};

export const accountUpdateIdentificationEmit = () => {
  EventRegister.emit(AccountUpdateIdentificationEvent);
};

export const withdrawalEmit = () => {
  EventRegister.emit(WithdrawalEvent);
};

export const requestReadEmit = () => {
  EventRegister.emit(RequestReadEvent);
};

export const requestUnreadCountRefreshEmit = () => {
  EventRegister.emit(RequestUnreadCountRefreshEvent);
};
